import { IPartnerApplicationTypes } from 'types/graphqlTypes'
import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const SearchSchema = yup.object({
  /**
   * @example 'ShipperApplication'
   */
  partnerType: yup
    .mixed<IPartnerApplicationTypes>()
    .oneOf([...Object.values(IPartnerApplicationTypes)])
    .required(REQUIRED_MESSAGE),
  /**
   * @example { id: '1241', text: '1720-shipper', data: { __typename: 'ShipperApplication' } }
   */
  company: yup
    .object({
      id: yup.string().notRequired(),
      text: yup.string().notRequired(),
    })
    .nullable(),
})

export type TSearchSchema = yup.InferType<typeof SearchSchema>
